import React from 'react';
import {
  MessageCardHeroDetail,
  MessageCardHeroImage,
  MessageCardHeroWrapper,
  MessageText,
} from './styles';
import useMediaQuery from '../hooks/useMediaQuery';
import {useSendChatAnalytic} from '../hooks/useSendChatAnalytic';

type MessageCardHeroProps = {
  href?: string;
  imageUrl?: string;
  title?: string;
  text?: string;
  isNewBlock?: boolean;
};

const MessageCardHero: React.FC<MessageCardHeroProps> = ({
  href,
  imageUrl,
  title,
  text,
  isNewBlock,
}) => {
  const {isDesktop} = useMediaQuery();
  const {handleHeroCardClick} = useSendChatAnalytic();

  return (
    <MessageCardHeroWrapper
      href={href}
      aria-label={title}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => handleHeroCardClick(title)}
      isNewBlock={isNewBlock}
      isMobile={!isDesktop}
    >
      <MessageCardHeroImage isDesktop={isDesktop} src={imageUrl} />
      <MessageCardHeroDetail>
        <MessageText fontWeight="bold" fontSize={14} lineHeight={21}>
          {title}
        </MessageText>
        <MessageText>{text}</MessageText>
      </MessageCardHeroDetail>
    </MessageCardHeroWrapper>
  );
};

export default MessageCardHero;
